import { useRef, useEffect } from "react";

interface Star {
  x: number; y: number; z: number; r: number;
  vx: number; vy: number; a: number;
  isAmbient: boolean;
  color?: string;
  pulsePhase?: number;
  pulseSpeed?: number;
}

export default function StarfieldCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d")!;
    const DPR = Math.min(2, window.devicePixelRatio || 1);
    let W = 0, H = 0;
    const stars: Star[] = [];
    let raf: number;

    function resize() {
      //kaviya
      const width = window.innerWidth;
const height = window.innerHeight;
      W = canvas!.width = Math.floor(width * DPR);
      H = canvas!.height = Math.floor(height * DPR);
      canvas!.style.width = width + "px";
      canvas!.style.height = height + "px";
    }

    function makeStars() {
      stars.length = 0;
      for (let i = 0; i < 120; i++) {
        stars.push({
          x: Math.random() * W, y: Math.random() * H,
          z: Math.random() + 0.2, r: Math.random() * 1.2 + 0.2,
          vx: (Math.random() * 0.25 + 0.05) * DPR, vy: 0,
          a: Math.random() * 0.6 + 0.2, isAmbient: false
        });
      }
      for (let i = 0; i < 20; i++) {
        stars.push({
          x: Math.random() * W, y: Math.random() * H,
          z: 0.1, r: Math.random() * 3 + 2,
          vx: (Math.random() * 0.1 - 0.05) * DPR,
          vy: -(Math.random() * 0.3 + 0.15) * DPR,
          a: Math.random() * 0.12 + 0.04, isAmbient: true,
          color: Math.random() > 0.5 ? "cyan" : "violet",
          pulsePhase: Math.random() * Math.PI * 2,
          pulseSpeed: Math.random() * 0.02 + 0.01
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      const g = ctx.createRadialGradient(W * 0.5, H * 0.5, 0, W * 0.5, H * 0.5, Math.max(W, H) * 0.55);
      g.addColorStop(0, "rgba(0,0,0,0)");
      g.addColorStop(1, "rgba(0,0,0,0.65)");
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      for (const s of stars) {
        if (s.isAmbient) {
          s.x += s.vx; s.y += s.vy;
          if (s.y < -20) { s.y = H + 20; s.x = Math.random() * W; }
          if (s.x < -20) s.x = W + 20;
          if (s.x > W + 20) s.x = -20;
          s.pulsePhase! += s.pulseSpeed!;
          const pa = s.a * (0.6 + 0.4 * Math.sin(s.pulsePhase!));
          const bc = s.color === "cyan" ? "54,231,255" : "180,107,255";
          ctx.save();
          ctx.shadowBlur = 15;
          ctx.shadowColor = `rgba(${bc},${pa * 2})`;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(${bc},${pa})`;
          ctx.fill();
          ctx.restore();
        } else {
          s.x += s.vx * s.z;
          if (s.x > W + 20) { s.x = -20; s.y = Math.random() * H; }
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r * DPR, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,255,255,${s.a})`;
          ctx.fill();
          if (Math.random() < 0.015) {
            ctx.strokeStyle = `rgba(54,231,255,${s.a * 0.5})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(s.x, s.y);
            ctx.lineTo(s.x - 30 * DPR * s.z, s.y);
            ctx.stroke();
          }
        }
      }
      raf = requestAnimationFrame(draw);
    }

    resize();
    makeStars();
    draw();
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <canvas ref={canvasRef} className="assess-bg-canvas" />;
}
